import { useContext } from 'react';
import FormModalContext from "./FormModalContext";

const useFormModalContext = () => {
    return useContext(FormModalContext)
}
export default useFormModalContext
